<app-wizard-bar-nav></app-wizard-bar-nav>
<div class="step-container">
  <h2 *ngIf="originalQuoteRequestId">Renewing Quote {{ originalQuoteRequestId }}</h2>
  <h3>File Validation | <em heading-info [quoteInfo]="quoteRequestState"></em></h3>

  <section>
    <table mat-table [dataSource]="dataSource" matSort class="noselect tenders-grid full-width">
      <ng-container matColumnDef="utilityAccountNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Utility Account Number</th>
        <td mat-cell *matCellDef="let data">
          <span>{{ data.utilityAccountNumber }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="startDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Usage Start Date</th>
        <td mat-cell *matCellDef="let data">
          <span>{{ data.startDate | date: dateFormat }}</span>
          <span *ngIf="!data.startDate">-</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="endDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Usage End Date</th>
        <td mat-cell *matCellDef="let data">
          <span>{{ data.endDate | date: dateFormat }}</span>
          <span *ngIf="!data.endDate">-</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="meterReadings">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Meter Readings</th>
        <td mat-cell *matCellDef="let data">
          <span>{{ data.meterReadings }}</span>
          <span *ngIf="!data.meterReadings">-</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="uploadConsumption">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Uploaded Usage<wbr /> <span style="text-transform: none">&nbsp;{{ utilityUOM$ | async | lowercase }}</span>
        </th>
        <td mat-cell *matCellDef="let data">
          <span>{{ data.uploadConsumption | number: '1.2-4' }}</span>
          <span *ngIf="data.uploadConsumption === undefined || data.uploadConsumption === null">-</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="days">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Days</th>
        <td mat-cell *matCellDef="let data">
          <span>{{ data.days }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="blanks">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Gaps</th>
        <td mat-cell *matCellDef="let data">
          <span>{{ data.blanks }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="fileName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>File Name</th>
        <td mat-cell *matCellDef="let data">
          {{ data.fileId }}
          <span
            ><a class="download-link" appDownloadLink [file]="data.file">{{ data.file.fileName }}</a></span
          >
          <span *ngIf="!data.file">-</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="info">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let data" style="text-align: end">
          <mat-icon *ngIf="data.valid" aria-hidden="false" aria-label="Usage Data Provided">
            <img src="../../../../assets/icons/icon_success.svg" class="icon-sm" aria-hidden="false" aria-label="File validated" />
          </mat-icon>
          <mat-icon
            *ngIf="!data.valid"
            aria-hidden="false"
            matTooltipClass="enable-line-break ud-tooltip"
            aria-label="No usage data file found for this Utility Account Number"
            matTooltip="{{ data.validationMessage }}"
            matTooltipPosition="after"
          >
            <img src="../../../../assets/icons/icon_error.svg" class="icon-sm" aria-hidden="false" aria-label="Validation error" />
          </mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="fix">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let data" style="width: 75px; text-align: end">
          <div *ngIf="!data.valid">
            <button class="fixBtn" mat-flat-button type="button" color="accent" (click)="showFixDialog(data)">
              <img src="../../../../assets/icons/icon_fix.svg" class="prefix" aria-hidden="false" aria-label="Fix data" />
              Fix
            </button>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="remove">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let data" style="width: 100px">
          <div class="delete-container button">
            <button
              class="delete-container-item"
              mat-stroked-button
              color="accent"
              type="button"
              (click)="deleteUtilityAccount(data.utilityAccountNumber)"
              [disabled]="isReadOnly()"
            >
              <mat-icon color="accent" matPrefix>delete</mat-icon>
              Delete
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </section>
</div>

<app-wizard-step-nav-buttons (backClicked)="back()" (nextClicked)="next()"></app-wizard-step-nav-buttons>
